import React from "react";
import { ReactComponent as TuringLogoText }  from "../../../../../../assets/img/turing_logo_text.svg"

import "./Header.scss";
import UserDropdown from "./Menu";

const Header = () => {

  return (
    <header className="turing-mobile-home-header">
      <div className="turing-mobile-home-header__main-section">
        <div><TuringLogoText style={{ width: '120px', height: 'auto' }} /></div>
        <UserDropdown />
      </div>
    </header>
  );
};

export default Header;
